import { Basket } from 'components/basket';
import { Footer, Navigation, Preloader } from 'components/common';
import * as ROUTES from 'constants/routes';
import { createBrowserHistory } from 'history';
import React, { lazy, Suspense, useEffect } from 'react';
//import { Route, Router, Switch } from 'react-router-dom';

import {
  HashRouter as Router,
  Redirect, Route, Switch, useLocation
  } from 'react-router-dom';

import * as view from 'views';
import AdminRoute from './AdminRoute';
import ClientRoute from './ClientRoute';
import PublicRoute from './PublicRoute';

// Revert back to history v4.10.0 because
// v5.0 breaks navigation
export const history = createBrowserHistory();

const CorporateHome = lazy(() => import('views/corporate/Home'));
const CorporateServices = lazy(() => import('views/corporate/Services'));
const CorporateServiceDetail = lazy(() => import('views/corporate/ServiceDetail'));
const CorporateAbout = lazy(() => import('views/corporate/About'));
const CorporateContact = lazy(() => import('views/corporate/Contact'));
const CorporateWork = lazy(() => import('views/corporate/Work'));
const CorporateGuides = lazy(() => import('views/corporate/Guides'));
const CorporateGuideDetail = lazy(() => import('views/corporate/GuideDetail'));
const CorporateLegal = lazy(() => import('views/corporate/Legal'));

const LegacyBasket = () => {
  const { pathname } = useLocation();
  const legacyCommercePath = pathname.startsWith('/product/')
    || pathname.startsWith('/search/')
    || pathname.startsWith('/checkout/');

  return legacyCommercePath ? <Basket /> : null;
};

const RouteIndexing = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const corporatePaths = [
      '/', '/services', '/work', '/guides', '/about', '/contact',
      '/privacy-policy', '/terms', '/cookie-policy'
    ];
    const indexable = corporatePaths.includes(pathname)
      || pathname.startsWith('/services/')
      || pathname.startsWith('/guides/')
      || pathname.startsWith('/user/');
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = indexable ? 'index, follow' : 'noindex, nofollow';
  }, [pathname]);

  return null;
};

const AppRouter = () => (
  <Router history={history}>
    <>
      <RouteIndexing />
      <Navigation />
      <LegacyBasket />
      <Suspense fallback={<Preloader />}>
        <Switch>
        <Route
          component={view.Search}
          exact
          path={ROUTES.SEARCH}
        />
        <Route
          component={CorporateHome}
          exact
          path={ROUTES.HOME}
        />
        <Route
          exact
          path={ROUTES.SHOP}
          render={() => <Redirect to={ROUTES.HOME} />}
        />
        <Route
          exact
          path={ROUTES.FEATURED_PRODUCTS}
          render={() => <Redirect to={ROUTES.HOME} />}
        />
        <Route
          exact
          path={ROUTES.RECOMMENDED_PRODUCTS}
          render={() => <Redirect to={ROUTES.HOME} />}
        />
        <Route
          component={CorporateServices}
          exact
          path={ROUTES.SERVICES}
        />
        <Route
          component={CorporateServiceDetail}
          path={ROUTES.SERVICE_DETAIL}
        />
        <Route
          component={CorporateWork}
          exact
          path={ROUTES.WORK}
        />
        <Route
          component={CorporateGuides}
          exact
          path={ROUTES.GUIDES}
        />
        <Route
          component={CorporateGuideDetail}
          path={ROUTES.GUIDE_DETAIL}
        />
        <Route
          component={CorporateAbout}
          exact
          path={ROUTES.ABOUT}
        />
        <Route
          component={CorporateContact}
          exact
          path={ROUTES.CONTACT}
        />
        <Route
          component={CorporateLegal}
          exact
          path={[ROUTES.PRIVACY_POLICY, ROUTES.TERMS, ROUTES.COOKIE_POLICY]}
        />
        <PublicRoute
          component={view.SignUp}
          path={ROUTES.SIGNUP}
        />
        <PublicRoute
          component={view.SignIn}
          exact
          path={ROUTES.SIGNIN}
        />
        <PublicRoute
          component={view.ForgotPassword}
          path={ROUTES.FORGOT_PASSWORD}
        />
        <Route
          component={view.ViewProduct}
          path={ROUTES.VIEW_PRODUCT}
        />
        <Route
          component={view.ViewUser}
          path={ROUTES.VIEW_User}
        />
        <ClientRoute
          component={view.UserAccount}
          exact
          path={ROUTES.ACCOUNT}
        />
        <ClientRoute
          component={view.EditAccount}
          exact
          path={ROUTES.ACCOUNT_EDIT}
        />
        <ClientRoute
          component={view.CheckOutStep1}
          path={ROUTES.CHECKOUT_STEP_1}
        />
        <ClientRoute
          component={view.CheckOutStep2}
          path={ROUTES.CHECKOUT_STEP_2}
        />
        <ClientRoute
          component={view.CheckOutStep3}
          path={ROUTES.CHECKOUT_STEP_3}
        />
        <AdminRoute
          component={view.Dashboard}
          exact
          path={ROUTES.ADMIN_DASHBOARD}
        />
        <AdminRoute
          component={view.Products}
          path={ROUTES.ADMIN_PRODUCTS}
        />
        <AdminRoute
          component={view.Users}
          path={ROUTES.ADMIN_USERS}
        />
        <AdminRoute
          component={view.Accounting}
          path={ROUTES.ADMIN_ACCOUNTING}
        />
        <AdminRoute
          component={view.Analytics}
          path={ROUTES.ADMIN_ANALYTICS}
        />
        <AdminRoute
          component={view.AddProduct}
          path={ROUTES.ADD_PRODUCT}
        />
        <AdminRoute
          component={view.EditProduct}
          path={`${ROUTES.EDIT_PRODUCT}/:id`}
        />
        <PublicRoute component={view.PageNotFound} />
        </Switch>
      </Suspense>
      <Footer />
    </>
  </Router>
);

export default AppRouter;
